module.exports = __webpack_public_path__ + "83c42967eb24c5bf5d4b31d70ef609c0.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/intro-panel-texture-420.webp
// module id = 414
// module chunks = 0